import { ComparisonOperators } from '@contentsquare/fov-constants';
export const browserCondition = {
    id: 'browser',
    category: 'technology',
    value: {
        browserAndVersionValues: [],
        operatorValues: [
            { value: ComparisonOperators.MATCH_EQUALS, label: 'CONDITION_SELECT_IS' },
            { value: ComparisonOperators.MATCH_NOT_EQUALS, label: 'CONDITION_SELECT_IS_NOT' },
        ],
    },
};
//# sourceMappingURL=browser-condition.value.js.map